import { AxiosPromise } from 'axios'
import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'
import type {
  GetCaseListParams,
  CaseListModel,
  UpdateCaseParams,
  UpdateCaseStatusParams,
  CaseListOptionsModel,
  GetCaseListOptions,
} from './type'

// 案例信息列表
export function getCaseList(
  params: GetCaseListParams,
): AxiosPromise<CaseListModel> {
  return request({
    url: v2Host + '/material/case/list',
    method: 'get',
    params: cookRequestParams(params),
  })
}

// 导出案例信息
export function exportCaseList(params: GetCaseListParams): AxiosPromise<any> {
  return request({
    url: v2Host + '/material/case/export',
    method: 'get',
    params: cookRequestParams(params),
  })
}

// 更新案例信息
export function updateCase(data: UpdateCaseParams): AxiosPromise {
  return request({
    url: v2Host + '/material/case/update',
    method: 'post',
    data: data,
  })
}

// 更新案例状态
export function updateCaseStatus(params: UpdateCaseStatusParams): AxiosPromise {
  return request({
    url: v2Host + '/material/case/update-status',
    method: 'post',
    params,
  })
}

// 搜索信息
export function fetchCaseOptions(
  params: GetCaseListOptions,
): AxiosPromise<CaseListOptionsModel> {
  return request({
    url: v2Host + '/material/case/options',
    method: 'get',
    params,
  })
}
